var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7643H12.05V13.7143V11.1929H13.6643V13.7143V13.7643H13.7143H16.2357V15.3786H13.7143H13.6643V15.4286V17.95H12.05V15.4286V15.3786H12H9.47857V13.7643H12ZM0.0501708 17.9492C0.0574106 16.9272 0.294663 15.9198 0.744583 15.0018C1.20183 14.0688 1.8666 13.2528 2.68795 12.6164C3.5093 11.98 4.46543 11.5401 5.48308 11.3304C6.48809 11.1233 7.52676 11.146 8.52143 11.3968V13.0801C7.75731 12.8215 6.94313 12.7445 6.14348 12.8554C5.32052 12.9696 4.53697 13.2796 3.85864 13.7594C3.18031 14.2391 2.62699 14.8746 2.24516 15.6125C1.871 16.3356 1.6722 17.1363 1.66452 17.95L0.0501708 17.9492ZM6.85714 10.2357C4.04333 10.2357 1.76429 7.95667 1.76429 5.14286C1.76429 2.32904 4.04333 0.05 6.85714 0.05C9.67096 0.05 11.95 2.32904 11.95 5.14286C11.95 7.95667 9.67096 10.2357 6.85714 10.2357ZM6.85714 8.62143C8.77904 8.62143 10.3357 7.06476 10.3357 5.14286C10.3357 3.22096 8.77904 1.66429 6.85714 1.66429C4.93524 1.66429 3.37857 3.22096 3.37857 5.14286C3.37857 7.06476 4.93524 8.62143 6.85714 8.62143Z",
    fill: "#fff",
    stroke: "#EEF1F6",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.6d55137e95db1ed4e40b3756ffb26eef.svg";
export { ForwardRef as ReactComponent };